// 鼠标悬浮显示信息弹窗组件，用于pc端
import { Box, PopoverOrigin, PopoverProps } from '@mui/material';
import { QuestionFilled } from '@zeelool/icon';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
import { bindFocus, bindHover, bindPopover, usePopupState } from 'material-ui-popup-state/hooks';
import { ReactNode, useEffect, useRef } from 'react';

interface CustomPopoverProps extends Omit<PopoverProps, 'content' | 'open'> {
  id: string;
  content: ReactNode;
  triggerComponent?: ReactNode;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  width?: number | string;
  // open?: boolean; // 调试的时候可以打开;
  noPadding?: boolean;
  onOpen?: () => void;
  /** 弹层打开/关闭状态（含悬停与键盘焦点） */
  onOpenChange?: (open: boolean) => void;
  interactionMode?: 'hover-focus' | 'hover-only';
}

export default function Popover({
  id,
  content,
  triggerComponent = <QuestionFilled className="text-[#a3a3a3] text-[14px] ml-2 cursor-pointer" />,
  anchorOrigin = {
    vertical: 'center',
    horizontal: 'right',
  },
  transformOrigin = {
    vertical: 'center',
    horizontal: 'left',
  },
  width = 400,
  // open = false,
  noPadding = false,
  onOpen,
  onOpenChange,
  interactionMode = 'hover-focus',
  ...restProps
}: CustomPopoverProps) {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: id,
  });
  const prevIsOpenRef = useRef(popupState.isOpen);

  // 监听 popupState.isOpen 的变化，当从 false 变为 true 时触发 onOpen
  useEffect(() => {
    if (popupState.isOpen && !prevIsOpenRef.current && onOpen) {
      onOpen();
    }
    prevIsOpenRef.current = popupState.isOpen;
  }, [popupState.isOpen, onOpen]);

  useEffect(() => {
    onOpenChange?.(popupState.isOpen);
  }, [popupState.isOpen, onOpenChange]);

  const triggerInteractionProps =
    interactionMode === 'hover-only'
      ? bindHover(popupState)
      : {
          ...bindHover(popupState),
          ...bindFocus(popupState),
        };

  return (
    <>
      <Box {...triggerInteractionProps}>{triggerComponent}</Box>
      <HoverPopover
        {...bindPopover(popupState)}
        // 锚点位置
        anchorOrigin={anchorOrigin}
        // 弹出位置
        transformOrigin={transformOrigin}
        marginThreshold={16}
        {...restProps}
      >
        <Box
          style={{
            width: typeof width === 'string' ? width : `${width}px`,
          }}
          className={`popover-content ${noPadding ? '' : 'p-16'}`}
        >
          {content}
        </Box>
      </HoverPopover>
    </>
  );
}
